import { ReactNode, useState } from "react";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
  ReactZoomPanPinchProps,
} from "react-zoom-pan-pinch";
import classes from "./zoomable.module.css";

type ZoomableProps = {
  children: ReactNode;
};

export const Zoomable = ({
  children,
  ...props
}: ReactZoomPanPinchProps & ZoomableProps) => {
  const [maxResolution, setMaxResolution] = useState(false);

  const onZoomStart = (
    ref: ReactZoomPanPinchRef,
    event: TouchEvent | MouseEvent,
  ) => {
    if (!maxResolution) {
      const wrapper = ref.instance.wrapperComponent;
      const imgElement = wrapper?.getElementsByTagName("img")[0];
      if (imgElement) {
        imgElement.sizes = "1000vw";
      }
      setMaxResolution(true);
    }
    if (props.onZoomStart) {
      props.onZoomStart(ref, event);
    }
  };

  return (
    <TransformWrapper
      panning={{ disabled: true, ...props.panning }}
      onZoomStart={onZoomStart}
      {...props}
    >
      <TransformComponent
        wrapperClass={classes.defaultReset}
        contentClass={classes.defaultReset}
      >
        {children}
      </TransformComponent>
    </TransformWrapper>
  );
};
